type ViewData = { sys_table_id?: string | { id: string } };

// RecordManagement#get devolve o envelope { success, data, meta }; a view vive em `data`.
export async function sectionPrefill(tableName: string, targetColumnName: string, routeId: string, getView: (id: string) => Promise<{ data?: ViewData | null } | null>) {
    const values: Record<string, string> = { [targetColumnName]: routeId };
    if (tableName === "sys_form_sections" && targetColumnName === "sys_form_view_id") {
        try {
            const view = await getView(routeId);
            const viewData = view?.data;
            const tableId = typeof viewData?.sys_table_id === "object" ? viewData.sys_table_id?.id : viewData?.sys_table_id;
            if (tableId) values.sys_table_id = tableId;
        } catch {
            // The existing view prefill still lets the client script resolve the table.
        }
    }
    return values;
}
